import React from 'react';
import { SiMinutemailer } from "react-icons/si";
import { HiOutlineLocationMarker } from "react-icons/hi";
import { PiPhoneDisconnectBold } from "react-icons/pi";


function NavHead() {
    return (
        <div className='main_nav_sub_head'>
            <div className='container'>
                <div className='row nav_sub_one'>
                    <div className='col mt-1'>
                        <span className='ms-3  '>
                            <SiMinutemailer className='ms-2 ' />&nbsp;
                            vilvattamscb337@gmail.com
                        </span>

                        <span className='ms-3 '>
                            |
                        </span>

                        <span className='ms-3 '>
                            <PiPhoneDisconnectBold />&nbsp;
                           0487-2695623, 2694717
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default NavHead;
